import { useEffect } from 'react';
import * as notifications from 'lib/notifications';
import { clientGet, userGetCurrent, userGroupList } from 'lib/api';
import useClient from '../Files/useClient';
import { IAppProps } from '../Files/FilesContainer';


export const useRequiredData = (userId: IAppProps["userId"]) => {
    const { client, setClient, currentUser, setCurrentUser, userGroups, setUserGroups, userHasPermission } = useClient();

    useEffect(() => {
        setClient(null);

        clientGet().then(data => {
            setClient(data);
        }).catch((reason) => {
            notifications.dispatchFromError("Fel vid hämtning av Företags data", reason, 15);
            setClient(null);
        });

        userGetCurrent().then(data => {
            setCurrentUser(data);
        }).catch((reason) => {
            notifications.dispatchFromError("Fel vid hämtning av CurrentUser data", reason, 15);
            setCurrentUser(null);
        });

        userGroupList().then(data => {
            setUserGroups(data);
        }).catch((reason) => {
            notifications.dispatchFromError("Fel vid hämtning av grupper", reason, 15);
        });
    }, [userId]);

    return {
        client,
        currentUser,
        userGroups,
        userHasPermission
    };
};
